// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media screen and (max-width: 768px) {\n.leo-input-otp .leo-input-otp__block .leo-input-otp__input[data-v-e5d693e6] {\n    height: calc(0.5rem * 4.75) !important;\n    width: calc(0.5rem * 3.75) !important;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
